import React from "react";
import { TeamMember } from "@chemaxon/terminus-client/ui/models/TeamMember";
import { Box } from "@mui/material";
import {
  Chip,
  Spacing1,
  Spacing2,
  Spacing3,
  Spacing5,
  Spacing8,
} from "@chemaxon/design-system";
import { Border, Surface, Secondary } from "@chemaxon/design-system/color";
import { Typography } from "@chemaxon/design-system/typography";

export default function GroupMembersContainer(props: Props) {
  const getMemberName = (id: number) => {
    const teamMember = props.teamMembers.find(tm => tm.id === id);

    return teamMember ? teamMember.userName : "";
  };

  const handleDelete = (memberId: number) => {
    props.setGroupMemberIds &&
      props.setGroupMemberIds(
        props.groupMemberIds.filter(id => id !== memberId),
      );
    props.onRemove && props.onRemove(memberId);
  };

  return (
    <>
      <Typography variant={"label2"}>
        Team members added to the group
      </Typography>
      <Box
        sx={{
          minHeight: Spacing8,
          gap: Spacing3,
          marginTop: Spacing2,
          border: "1px solid",
          borderColor: Border.default.main,
          borderRadius: 1,
          backgroundColor: Surface.variant,
          padding: `${Spacing3} ${Spacing3} ${Spacing3} ${Spacing5}`,
          "& > :not(:last-child)": { marginRight: 1 },
          "& > *": { marginBottom: 1 },
        }}
      >
        {props.groupMemberIds.map(option => (
          <Chip
            key={"groupMember_" + option}
            size={"small"}
            unselectable={"on"}
            disabled={props.disabled}
            sx={{
              backgroundColor: Secondary.container.main,
              color: Secondary.container.text,
              "& .MuiChip-deleteIcon": {
                backgroundColor: Secondary.container.main,
                color: Secondary.container.text,
                padding: Spacing1,
              },
            }}
            label={getMemberName(option)}
            onDelete={() => handleDelete(option)}
          />
        ))}
      </Box>
    </>
  );
}

type Props = {
  groupMemberIds: number[];
  setGroupMemberIds?: React.Dispatch<React.SetStateAction<number[]>>;
  teamMembers: TeamMember[];
  onRemove?: (value: number) => void;
  disabled: boolean;
};
